// sentry
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

export { Sentry };

export default app => {
  Sentry.init({
    app,
    dsn: import.meta.env.DEV
      ? 'https://5e0fa65ccb4048a29615d1263c3aa3b2@sentry.tosoiot.com/5'
      : 'https://07c3d7d0b2cb4819bc251ff99f3e426d@sentry.tosoiot.com/3',
    // dsn: 'http://07c3d7d0b2cb4819bc251ff99f3e426d@123.60.82.108:9000/3',
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: ['www.tosoiot.com'],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
};

export const sendLog = msg => {
  // Sentry.captureMessage(`[user_event]: ${msg}`);
  // Sentry.setTag('user_event', msg);
};

export const sendError = err => {
  Sentry.captureException(new Error(err));
};
